<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full">
    <div class="w-96 max-h-full rounded-lg bg-white">
        <div class="fixed top-56 bg-primary-purple-light-2 pl-6 pr-6 rounded-lg shadow w-96">
            <div [hidden]="updating">
                <div class="flex justify-center">
                    <h3 class="w-full text-base font-bold mb-3 dark:text-gray-400 mt-5">{{
                        literalService.get('bookings.modal.editField', true) }}</h3>
                    <button (click)="modal.hide()" type="button"
                        class="absolute top-2 right-2 mr-2 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                       >
                        <img [src]="images.close" class="h-6 w-6" />
                    </button>
                </div>
                <div class="pt-2 mb-5" [ngClass]="{'text-neutrals-grey-03': confirmChange}">
                    @if (booking && originElement && destinationElement) {
                        <div>
                            <app-input [data]="originElement" [edit]="true" [independent]="true" [translateValue]="false"
                                [hasErrors]="false" [error]="'showError(element.value, element.edit?.valueToChange)'"
                                (setEventEmitter)="$event.value && setOrigin($event.value)" />
                        </div>
                        <div class="mt-5">
                            <app-input [data]="destinationElement" [edit]="true" [independent]="true"
                                [translateValue]="false" [hasErrors]="false"
                                [error]="'showError(element.value, element.edit?.valueToChange)'"
                                (setEventEmitter)="$event.value && setDestination($event.value)" />
                        </div>
                    }
                </div>
                @if (showRecomputePriceToggle) {
                    <div class="flex items-center justify-between mb-2">
                        <div class="flex gap-2 items-center">
                            <img [src]="images.booking.fare" alt="recomputePrice" class="h-6 w-6" />
                            <label class="font-bold">{{ literalService.get('bookings.actions.editBooking.recomputePrice', true) }}</label>
                        </div>
                        <app-toggle [id]="'recomputePrice'" [checked]="recomputePrice" (change)="recomputePrice = !recomputePrice;"></app-toggle>
                    </div>
                }
                <div class="flex items-center justify-between mb-2">
                    <div class="flex gap-2 items-center">
                        <img [src]="images.booking.notifications" alt="notify" class="h-6 w-6" />
                        <label class="font-bold">{{ literalService.get('bookings.actions.deleteBooking.notify', true) }}</label>
                    </div>
                    <app-toggle [id]="'notify'" [checked]="notify" (change)="notify = !notify;"></app-toggle>
                </div>
                @if (confirmChange) {
                    <div class="my-8 max-w-96">
                        <p class="font-bold mb-2">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.title', true) }}</p>
                        <p class="text-base font-normal">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.pre', true) }}<span class="text-primary-purple font-semibold">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.highlight', true) }}</span>{{ literalService.get('bookings.actions.editBooking.ticketingAlert.post', true) }}</p>
                    </div>
                }
                <div class="flex items-center space-x-4 pb-4 w-full">
                    <button (click)="onCancel()" type="button"
                        class="secondary mt-2 p-2 border-2 min-w-28 w-full font-semibold uppercase cursor-pointer">{{
                        literalService.get('cancel', true) }}</button>
                    <button type="button"
                        class="primary mt-2 p-2 border-2 min-w-28 w-full font-semibold text-white uppercase cursor-pointer"
                        (click)="onSubmit()">{{ literalService.get(confirmChange ? 'confirm' : 'update', true) }}</button>
                </div>
            </div>
            <div [hidden]="!updating">
                <article class="flex w-72 justify-center items-center">
                    <ng-lottie [options]="optionsBus" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
                </article>
                <article class="flex w-72 justify-center items-center">
                    <h3 class="text-xl font-bold mb-4 -mt-4 text-primary-purple-light">
                        {{ literalService.get('updatingBooking', true)}}</h3>
                </article>
            </div>
        </div>
    </div>
</div>